import { BuildingIcon } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { LogoEditorRenderer } from "./editor";
import { LogoEmailRenderer } from "./email";
import type { LogoBlockProps, LogoSize } from "./types";
import { LogoEmailPanelRenderer } from "./email-panel";
import LogoWeb from "./web";
import { LogoWebEditor } from "./web-editor";


export const logoSizeMap: Record<LogoSize, number> = {
  small: 24,
  medium: 60,
  large: 120,
};

export default registerBlock<LogoBlockProps>({
  type: "logo",
  name: "editorBlocksLibrary.blocks.logo.title",
  description: "editorBlocksLibrary.blocks.logo.description",
  Icon: BuildingIcon,
  category: BlockCategory.LAYOUT,
  components: {
    email: {
      component: LogoEmailRenderer,
      editor: {
        component: LogoEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: LogoEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: true,
      },
    },
    web: {
      component: LogoWeb,
      editor: {
        component: LogoWebEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: LogoEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: true,
      },
    },
  },
});

export type { LogoBlockProps as LogoEditorRendererProps } from "./types";
